import { combineReducers } from 'redux';
import { handleAction } from 'redux-actions';
import { concat, compose, ifElse, isEmpty, filter } from 'ramda';

import { TRANSLATIONS_FETCHED } from 'app/features/localization/actionTypes';
import defaults from 'app/features/localization/translations.json';
import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import {
  DEFAULT_LOCALE,
  LOCALE_MAP,
} from 'app/features/localization/constants';
import { MAIN_SETUP } from 'app/features/deltaConfig/constants';
import { pickState, pathOrFromPayload } from 'app/reducers/helpers';

const mergePayload = (state, { payload }) => ({
  ...state,
  ...defaults,
  ...filter(Boolean, payload),
});

const translations = handleAction(TRANSLATIONS_FETCHED, mergePayload, defaults);

const availableLocales = pathOrFromPayload(
  [],
  [MAIN_SETUP, 'availableLocales'],
);
const setLocaleMap = ifElse(
  compose(isEmpty, availableLocales),
  pickState,
  compose(concat([DEFAULT_LOCALE]), availableLocales),
);
const locales = handleAction(
  FETCH_DELTA_CONFIG_SUCCESS,
  setLocaleMap,
  Object.keys(LOCALE_MAP),
);

export { translations, locales };

export default combineReducers({ locales, translations });
